/* src/pages/Dashboard/Settings/Settings.jsx
   --------------------------------------------------------------- */
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Backdrop, CircularProgress, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import sessionstorage from "sessionstorage";

import backend from "../../../../../api";
import { authActions } from "../../../../../redux-store";
import { setUserData } from "../../../../../redux-store/auth/actions";
import Classes from "./Settings.module.css";

import Account from "./Comp/Account";
import { ProfileIcon, LogoutIcon } from "../../../../../utils/Icons";

export default function Settings() {
  const { user } = useSelector((s) => s.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();

  const [active, setActive] = useState(1);
  const [saving, setSaving] = useState(false);

  /* universal save helper passed down to Account component */
  const saveUser = async (patch) => {
    setSaving(true);
    try {
      const { data } = await backend.put(`/api/user/${user._id}`, patch);
      dispatch(setUserData({ ...user, ...data.data }));
      localStorage.setItem("user", JSON.stringify({ ...user, ...data.data }));
    } finally {
      setSaving(false);
    }
  };

  /* logout */
  const handleLogout = async () => {
    localStorage.clear();
    sessionstorage.clear();
    await dispatch(authActions.logout());
    navigate("/");
  };

  const sidebar = [
    { id: 1, label: "Account", icon: <ProfileIcon height="15" width="15" fill="white" /> },
  ];

  const Step = active === 1 ? <Account saveUser={saveUser} /> : null;

  return (
    <>
      <Backdrop open={saving} sx={{ zIndex: theme.zIndex.tooltip + 1, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <div className={Classes.container}>
        <div className={Classes.header}>
          <div>
            <h3 className={Classes.title3}>Settings</h3>
            <h5 className={Classes.text}>Manage your account settings.</h5>
          </div>
        </div>

        <div className={Classes.hero}>
          {/* sidebar */}
          <div className={Classes.sidebar}>
            {sidebar.map((s) => (
              <div
                key={s.id}
                role="button"
                onClick={() => setActive(s.id)}
                className={`${Classes.sideElement} ${active === s.id ? Classes.current : ""}`}
              >
                <div className={Classes.flexAlign10}>
                  <div className={`${Classes.imageCon} ${active === s.id ? Classes.active : ""}`}>
                    {s.icon}
                  </div>
                  <h5 className={active === s.id ? Classes.activeText : ""}>{s.label}</h5>
                </div>
              </div>
            ))}

            {/* logout */}
            <div className={Classes.sideElement} role="button" onClick={handleLogout}>
              <div className={Classes.flexAlign10}>
                <div className={Classes.imageCon}>
                  <LogoutIcon height="15" width="15" fill="white" />
                </div>
                <h5>Logout</h5>
              </div>
            </div>
          </div>

          {/* main */}
          {Step}
        </div>
      </div>
    </>
  );
}
